import { Component, Input, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_SCHEDULER_IMPORTS } from "@app/scheduler/common-scheduler-imports"
import { SchedulerComponent } from "@app/scheduler/scheduler.component"

@Component({
	selector: "app-task-scheduler",
	imports: [COMMON_SCHEDULER_IMPORTS],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "../scheduler/scheduler.component.html",
})
export class TaskSchedulerComponent extends SchedulerComponent {
	@Input() content: string

	async handleSubmit() {
		const daysArr = this.data.daysArr.map((it) => Number(it.num))
		const sendObj = {
			...this.data,
			daysArr,
			patient_id: this.patient_id,
			content: this.content,
		}
		this.isSaving = true
		const res: any = await this.apiService.post("create_taskschedule", sendObj)
		this.isSaving = false
		if (res?.id) {
			this.store.addGenItemRow("taskschedules", res)
		}
		this.modalService.openToast(
			res?.id ? "created_successfully" : "save_failed"
		)
		this.onClose.emit(res?.id)
	}
}
